module.exports = __webpack_public_path__ + "assets/207479353841ed9ae8bd0e9348e89bb6.mp3";